import { FC, PropsWithChildren } from 'react';

import { Stack } from '@eneco/sparky';

import { styledWrapperClass, centerViewportClass } from './CenterInViewport.css';


export const CenterInViewport: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styledWrapperClass}>
      <Stack className={centerViewportClass} direction="row" alignX="center" alignY="center">
        <Stack.Item>{children}</Stack.Item>
      </Stack>
    </div>
  );
};
